var si = typeof setImmediate === 'function',
  tick;
if (si) {
  tick = function tick(fn) {
    setImmediate(fn);
  };
} else {
  tick = function tick(fn) {
    setTimeout(fn, 0);
  };
}
module.exports = tick;